module.exports = __webpack_public_path__ + "media/images/PreventionPlanningTeams-2b80e4d297b1aa3fcd73af9c24a957b8.png";